"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var StringFunctions_1 = __importDefault(require("../libs/StringFunctions"));
var Input = /** @class */ (function (_super) {
    __extends(Input, _super);
    function Input(props) {
        var _this = _super.call(this, props) || this;
        _this.state = props;
        return _this;
    }
    Input.prototype.componentWillReceiveProps = function (props) {
        this.setState(props);
    };
    Input.prototype.onChange = function (item) {
        item.target.value = StringFunctions_1.default.correctInputString(item.target.value);
        if (this.props.pattern !== "") {
            item.target.value = String(item.target.value).match(this.props.pattern);
        }
        this.state.onChange(item);
    };
    Input.prototype.render = function () {
        var currentType = this.state.type;
        if (currentType === 'number') {
            currentType = 'text';
        }
        return (react_1.default.createElement("input", { step: "any", onChange: this.onChange.bind(this), name: this.state.name, autoComplete: this.state.autoComplete, id: this.state.id, type: currentType, value: this.state.value, className: this.state.className, defaultChecked: this.state.defaultChecked, placeholder: this.state.placeholder, checked: this.state.checked }));
    };
    Input.defaultProps = {
        onChange: function () { },
        id: "",
        type: "text",
        value: "",
        name: '',
        className: "",
        placeholder: null,
        pattern: "",
    };
    return Input;
}(react_1.Component));
exports.default = Input;
;
//# sourceMappingURL=Input.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/saffroncodejs/lib/ui/Input.js
// module id = 103
// module chunks = 0